export enum EHolotrakDeviceFeatures {
    diagnostics = 'diagnostics',
    externalBattery = 'external_battery',
    internalBattery = 'internal_battery',
    onDeviceGeofencing = 'on_device_geofencing',
    doorSensor = 'door_sensor',
    lightSensor = 'light_sensor',
    flightSensor = 'flight_sensor',
    locationSensor = 'location_sensor',
    recovery = 'recovery',
    basicInputOutput = 'basic_input_output',
    bluetoothAccessory = 'bluetooth_accessory',
    virtualIgnition = 'virtual_ignition',
    welding_can = 'welding_can',
}

export function getHolotrakDeviceFeaturesFromString(value: string): EHolotrakDeviceFeatures {
    switch (`${value}`.toLowerCase().trim()) {
        case 'welding_can':
            return EHolotrakDeviceFeatures.welding_can;
        case 'virtual_ignition':
            return EHolotrakDeviceFeatures.virtualIgnition;

        case 'on_device_geofencing':
            return EHolotrakDeviceFeatures.onDeviceGeofencing;

        case 'flight_sensor':
            return EHolotrakDeviceFeatures.flightSensor;

        case 'external_battery':
            return EHolotrakDeviceFeatures.externalBattery;

        case 'internal_battery':
            return EHolotrakDeviceFeatures.internalBattery;

        case 'door_sensor':
            return EHolotrakDeviceFeatures.doorSensor;

        case 'light_sensor':
            return EHolotrakDeviceFeatures.lightSensor;

        case 'location_sensor':
            return EHolotrakDeviceFeatures.locationSensor;

        case 'basic_input_output':
            return EHolotrakDeviceFeatures.basicInputOutput;

        case 'bluetooth_accessory':
            return EHolotrakDeviceFeatures.bluetoothAccessory;

        case 'recovery':
            return EHolotrakDeviceFeatures.recovery;

        case 'diagnostics':
        default:
            return EHolotrakDeviceFeatures.diagnostics;
    }
}
